import React from "react"
import { Field } from "formik"
import SelectInput from "@components/form/inputs/SelectInput"
import { hookOnChange } from "../../utils"

const SelectField = ({
  name,
  label,
  options,
  onChange = (...args: any) => {},
  autoComplete = "off",
  className,
  disabled,
}: any) => (
  <Field name={name}>
    {({ field, form }) => {
      const error = form.errors && form.errors[name]
      const [touched, setTouched] = React.useState<boolean>(false)

      const handleOnChange = (args) => {
        console.log("ONCHANGE")
        if (!touched) {
          setTouched(true)
        }

        onChange(args)
      }

      return (
        <SelectInput
          {...field}
          label={label}
          options={options}
          onChange={hookOnChange(field, handleOnChange)}
          error={!!touched && !!error}
          helperText={touched && error ? error : undefined}
          autoComplete={autoComplete}
          className={className}
          disabled={!!disabled}
        />
      )
    }}
  </Field>
)

export default SelectField
